import React, { useState } from 'react';
import './RequestPortal.css';

const RequestPortal = () => {
    const [selectedOutfit, setSelectedOutfit] = useState('');
    const [selectedTopOutfit, setSelectedTopOutfit] = useState('');
    const [selectedPose, setSelectedPose] = useState('');

    // Example outfit options (bottom wear)
    const outfitOptions = [
        { id: 'outfit1', label: 'jockstrap' },
        { id: 'outfit2', label: 'thong' },
        { id: 'outfit3', label: 'mesh' },
        { id: 'outfit4', label: 'briefs' },
        { id: 'outfit5', label: 'trunks' },
        { id: 'outfit6', label: 'loose boxers' },
        { id: 'outfit7', label: 'athletic shorts' },
        { id: 'outfit8', label: 'chino pants' },
        { id: 'outfit9', label: 'chino shorts' },
        { id: 'outfit10', label: 'random' },
    ];

    // Add top outfit options
    const topOutfitOptions = [
        { id: 'top1', label: 'shirtless' },
        { id: 'top2', label: 't-shirt' },
        { id: 'top3', label: 'tank top' },
        { id: 'top4', label: 'dress shirt long sleeve' },
        { id: 'top5', label: 'dress shirt short sleeve' },
        { id: 'top6', label: 'crew neck sweater' },
        { id: 'top7', label: 'hoodie' },
        { id: 'top8', label: 'crop top T' },
        { id: 'top9', label: 'crop top tank' },
        { id: 'top10', label: 'Polo' },
        { id: 'top11', label: 'random' },
    ];
    
    // Example pose options
    const poseOptions = [
        { id: 'pose1', label: 'Front Flex' },
        { id: 'pose2', label: 'Back Flex' },
        { id: 'pose3', label: 'Hands and knees' },
        { id: 'pose4', label: 'Hand Stand' },
        { id: 'pose5', label: 'Hammies say hello' },
        { id: 'pose6', label: 'Prone' },
        { id: 'pose7', label: 'Star Gazing' },
        { id: 'pose8', label: 'Random' },
    ];
    
    return (
        <div className="request-portal">
            <h1>Custom Content Request</h1>
            
            <form className="request-form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-section">
                    <h2>Step 1: Select Top</h2>
                    <div className="option-group">
                        {topOutfitOptions.map(option => (
                            <div className="option-item" key={option.id}>
                                <input
                                    type="radio"
                                    id={option.id}
                                    name="topOutfit"
                                    value={option.id}
                                    checked={selectedTopOutfit === option.id}
                                    onChange={() => setSelectedTopOutfit(option.id)}
                                    required
                                />
                                <label htmlFor={option.id}>{option.label}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="form-section">
                    <h2>Step 2: Select Bottom</h2>
                    <div className="option-group">
                        {outfitOptions.map(option => (
                            <div className="option-item" key={option.id}>
                                <input
                                    type="radio"
                                    id={option.id}
                                    name="outfit"
                                    value={option.id}
                                    checked={selectedOutfit === option.id}
                                    onChange={() => setSelectedOutfit(option.id)}
                                    required
                                />
                                <label htmlFor={option.id}>{option.label}</label>
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className="form-section">
                    <h2>Step 3: Select Pose</h2>
                    <div className="option-group">
                        {poseOptions.map(option => (
                            <div className="option-item" key={option.id}>
                                <input
                                    type="radio"
                                    id={option.id}
                                    name="pose"
                                    value={option.id}
                                    checked={selectedPose === option.id}
                                    onChange={() => setSelectedPose(option.id)}
                                    required
                                />
                                <label htmlFor={option.id}>{option.label}</label>
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className="form-section">
                    <h2>Step 4: Submit Request</h2>
                    <button
                        type="submit"
                        className="submit-button"
                        disabled
                    >
                        Requests closed
                    </button>
                    <p className="submission-info">
                        Custom content requests are closed for the time being. Already-purchased content
                        remains available in your "Purchased Content Folder" as long as you have an active
                        Pro membership.
                    </p>
                </div>
            </form>
        </div>
    );
};

export default RequestPortal;
